import React from 'react'
import "./whatGPT3.css"
import {Feature}from "../../components/index" 
const WhatGPT3 = () => {
  return (
    <div className="gpt3__whatgpt3 section__margin" id="wgpt3">
      
        <div className="gpt3__whatgpt3-feature">
          <Feature title="What is GPT3" text = "GPT-3, or the third-generation Generative Pre-trained Transformer, is a neural network machine learning model trained using internet data to generate any type of text. Developed by OpenAI, it requires a small amount of input text to generate large volumes of relevant and sophisticated machine-generated text." structureClass={"row"}/>
        </div>
        <div className='gpt3__whatgpt3-heading'>
          <h1 className='gradient__text'>
          The possibilities are beyond your imagination 
          </h1>
          <p>Explore The Library</p>

        </div>
        <div className='gpt3__whatgpt3-container'>
          <Feature title="Chatbots" text ="GPT-3 chatbots are programmable artificial intelligence applications built on development work by OpenAPI and powered by the GPT-3 language model."/>
          <Feature title="Knowledgebase" text="The sheer depth and scope of knowledge it seems to possess are astounding, and its continued development is sure to have a significant impact on the future of conversational AI."/>
          <Feature title="Education" text="GPT-3 allows users who are not experts in a given topic area to quickly access relevant information about that topic area when they need it most"/>

        </div>

      
    </div>
    
  )
}

export default WhatGPT3